import React from 'react'

import {
    EmptyThumb,
    RoomBadge,
    RoomButton,
    RoomCapacity,
    RoomContent,
    RoomHeader,
    RoomMeta,
    RoomName,
    RoomThumb,
} from './styles'
import imageIconUrl from '../../assets/icons/image.svg'
import seatIconUrl from '../../assets/icons/seat.svg'

import type { Room } from '../../models/rooms'

type RoomRowProps = {
    room: Room
    isAttached: boolean
    isAttaching: boolean
    onAttach: (roomId: string) => void
}

function RoomThumbnail({ room }: { room: Room }) {
    if (room.thumb) {
        return <RoomThumb aria-hidden="true" $thumb={room.thumb} />
    }

    if (room.thumbKey) {
        return <RoomThumb aria-hidden="true" $thumbKey={room.thumbKey} />
    }

    return (
        <EmptyThumb aria-hidden="true">
            <img src={imageIconUrl} alt="" />
        </EmptyThumb>
    )
}

export function RoomRow({ room, isAttached, isAttaching, onAttach }: RoomRowProps) {
    return (
        <RoomButton
            type="button"
            $attached={isAttached}
            disabled={isAttaching}
            onClick={() => onAttach(room.id)}
        >
            <RoomThumbnail room={room} />

            <RoomContent>
                <RoomHeader>
                    <RoomName>{room.name}</RoomName>
                    {isAttached ? <RoomBadge>Attached</RoomBadge> : null}
                </RoomHeader>
                <RoomMeta>{room.details}</RoomMeta>
            </RoomContent>

            <RoomCapacity>
                <span>{isAttaching ? '...' : room.capacity}</span>
                <img src={seatIconUrl} alt="" aria-hidden="true" />
            </RoomCapacity>
        </RoomButton>
    )
}
